import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    // Support param-based toggle (modal comments)
    const commentId = event.params?.id
    if (commentId) {
      const replyForm = document.getElementById(`modal_comment_${commentId}_reply_form`)
      if (!replyForm) return

      const isVisible = replyForm.style.display !== "none"
      replyForm.style.display = isVisible ? "none" : "block"

      if (!isVisible) {
        const input = replyForm.querySelector("input[name='post_comment[body]']")
        if (input) input.focus()
      }
      return
    }

    // Target-based toggle (market comments)
    if (this.hasFormTarget) {
      this.formTarget.classList.toggle("hidden")
      if (!this.formTarget.classList.contains("hidden")) {
        const textarea = this.formTarget.querySelector("textarea")
        if (textarea) textarea.focus()
      }
    }
  }

  toggleReplies(event) {
    const commentId = event.params?.id
    if (!commentId) return

    const repliesContainer = document.getElementById(`modal_comment_${commentId}_replies`)
    const label = document.getElementById(`modal_comment_${commentId}_replies_label`)
    const button = event.currentTarget
    const icon = button.querySelector("svg")

    if (!repliesContainer) return

    const isHidden = repliesContainer.classList.contains("modal-comment__replies--hidden")

    const parentComment = document.getElementById(`modal_comment_${commentId}`)

    if (isHidden) {
      repliesContainer.classList.remove("modal-comment__replies--hidden")
      if (icon) icon.style.transform = "rotate(90deg)"
      if (label) label.textContent = button.dataset.hideText || "Ocultar"
      if (parentComment) parentComment.classList.add("modal-comment--replies-open")
    } else {
      repliesContainer.classList.add("modal-comment__replies--hidden")
      if (icon) icon.style.transform = ""
      if (label) label.textContent = button.dataset.viewText || "Ver respostas"
      if (parentComment) parentComment.classList.remove("modal-comment--replies-open")
    }
  }

  hide() {
    if (this.hasFormTarget) {
      this.formTarget.classList.add("hidden")
    }
  }
}
